(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["pagebook-gallery"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const modal = document.getElementById('imageModal');
    const modalImage = document.getElementById('modalImage');
    const modalClose = document.getElementById('modalClose');
    const modalPrev = document.getElementById('modalPrev');
    const modalNext = document.getElementById('modalNext');
    const galleryImages = document.querySelectorAll('.gallery-image');
    
    let currentIndex = 0;
    let images = [];

    // Initialize images array from gallery
    galleryImages.forEach((img) => {
      images.push(img.src);
    });

    // Open modal on image click
    document.querySelectorAll('.gallery-item').forEach((item) => {
      item.addEventListener('click', function() {
        currentIndex = parseInt(this.getAttribute('data-index'));
        openModal();
      });
    });

    function openModal() {
      modalImage.src = images[currentIndex];
      modal.classList.add('active');
    }

    function closeModal() {
      modal.classList.remove('active');
    }

    function showNextImage() {
      currentIndex = (currentIndex + 1) % images.length;
      modalImage.src = images[currentIndex];
    }

    function showPrevImage() {
      currentIndex = (currentIndex - 1 + images.length) % images.length;
      modalImage.src = images[currentIndex];
    }

    modalClose.addEventListener('click', closeModal);
    modalPrev.addEventListener('click', showPrevImage);
    modalNext.addEventListener('click', showNextImage);
    modal.addEventListener('click', function(e) {
      if (e.target === modal) closeModal();
    });

    // Keyboard navigation
    document.addEventListener('keydown', function(e) {
      if (modal.classList.contains('active')) {
        if (e.key === 'ArrowLeft') showPrevImage();
        if (e.key === 'ArrowRight') showNextImage();
        if (e.key === 'Escape') closeModal();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
